// Centralized "Year Make Model" formatter — used by the Status Updates row, the
// Daily Route Summary table, and the printable HTML so vehicle text reads identically
// across surfaces. Defensive against null year (the DB column is nullable) and missing
// make/model — returns an empty string when nothing is present so callers can choose
// whether to render the line at all.

interface VehicleParts {
  vehicleYear?: number | null;
  vehicleMake?: string | null;
  vehicleModel?: string | null;
}

export function formatVehicleLine(parts: VehicleParts): string {
  return [parts.vehicleYear, parts.vehicleMake, parts.vehicleModel]
    .filter(p => p !== null && p !== undefined && p !== '')
    .join(' ')
    .trim();
}
